export var ActivityStatus;
(function (ActivityStatus) {
    ActivityStatus["FAILED"] = "FAILED";
    ActivityStatus["LOADING"] = "LOADING";
    ActivityStatus["ENDED"] = "ENDED";
    ActivityStatus["UNJOINED"] = "UNJOINED";
    ActivityStatus["HAVE_FREE_CARD"] = "HAVE_FREE_CARD";
    ActivityStatus["ON_PROGRESS"] = "ON_PROGRESS";
})(ActivityStatus || (ActivityStatus = {}));
export var RecordTabType;
(function (RecordTabType) {
    RecordTabType["REWARD"] = "REWARD";
    RecordTabType["ASSIST"] = "ASSIST";
})(RecordTabType || (RecordTabType = {}));
export var ExplorePhase;
(function (ExplorePhase) {
    ExplorePhase["PRE_BOOK"] = "PRE_BOOK";
    ExplorePhase["SAME_DAY"] = "SAME_DAY";
})(ExplorePhase || (ExplorePhase = {}));
export const ACTIVITY_OFFLINE_CODE = 10003;
export const ACTIVITY_BLOKCED_CODE = 14001;
export const NOT_VALID_FOR_ACTIVITY = 12001;
export const INVALID_CODES = [ACTIVITY_OFFLINE_CODE, ACTIVITY_BLOKCED_CODE, NOT_VALID_FOR_ACTIVITY];
export const USER_INFO_VALID_CODE = 401;
export const USER_INFO_VALID_MSG = '登录信息错误';
export var API_PATH;
(function (API_PATH) {
    API_PATH["QUERY_INFO"] = "/api/altas/marketing/activity/query/info";
    API_PATH["RECOMMEND_CITIES"] = "/api/altas/marketing/recommend/cities";
    API_PATH["JOIN_ACTIVITY"] = "/api/altas/marketing/activity/join/activity";
    API_PATH["TASK_COMPLETE"] = "/api/altas/marketing/task/complete";
    /** 奖励记录查询 */
    API_PATH["REWARDS"] = "/api/altas/marketing/query/user/reward";
    /** 打Call记录查询 */
    API_PATH["ASSIST_RECORD"] = "/api/altas/marketing/query/assist/record";
    /** 免单卡获奖公告查询 */
    API_PATH["FREE_ORDER_CARD_LEADERBOARD"] = "/api/altas/marketing/query/freeOrderCard/leaderboard";
    /** 通用弹窗频控查询 */
    API_PATH["QUERY_POPUP_CACHE"] = "/api/altas/marketing/query/popup/cache";
})(API_PATH || (API_PATH = {}));
export var InviteType;
(function (InviteType) {
    InviteType[InviteType["INVITE_ASSIST"] = 1] = "INVITE_ASSIST";
})(InviteType || (InviteType = {}));
export var ClickFreeCardUseBtnTriggerFlowType;
(function (ClickFreeCardUseBtnTriggerFlowType) {
    ClickFreeCardUseBtnTriggerFlowType["OPEN_BOTTOM_MODAL"] = "openBottomModal";
    ClickFreeCardUseBtnTriggerFlowType["JUMP_TO_ANCHOR"] = "jumpToAnchor";
})(ClickFreeCardUseBtnTriggerFlowType || (ClickFreeCardUseBtnTriggerFlowType = {}));
